import { render } from "./PublicGallery.vue?vue&type=template&id=392c55b6&scoped=true"
import script from "./PublicGallery.vue?vue&type=script&lang=js"
export * from "./PublicGallery.vue?vue&type=script&lang=js"

import "./PublicGallery.vue?vue&type=style&index=0&id=392c55b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392c55b6"]])

export default __exports__